var zoomInWhenMouseMove = function zoomInWhenMouseMove(e) {
  var imagezoom = e.target.closest('.image-zoom-js');
  imagezoom.style.setProperty('--display', 'block');
  var pointer = {
    x: e.offsetX * 100 / imagezoom.offsetWidth,
    y: e.offsetY * 100 / imagezoom.offsetHeight
  };
  imagezoom.style.setProperty('--zoom-x', pointer.x + '%');
  imagezoom.style.setProperty('--zoom-y', pointer.y + '%');
};
var zoomOutWhenMouseOut = function zoomOutWhenMouseOut(e) {
  var imagezoom = e.target.closest('.image-zoom-js');
  imagezoom.style.setProperty('--display', 'none');
};
var activateZoom = function activateZoom(imagezoom) {
  imagezoom.addEventListener('mousemove', zoomInWhenMouseMove, true);
  imagezoom.addEventListener('mouseout', zoomOutWhenMouseOut);
};
var deactivateZoom = function deactivateZoom(imagezoom) {
  imagezoom.removeEventListener("mousemove", zoomInWhenMouseMove, true);
  imagezoom.style.setProperty('--display', 'none');
};
var initImageZoom = function initImageZoom() {
  var imageZooms = document.querySelectorAll('.image-zoom-js');
  if (!imageZooms) {
    return;
  }
  imageZooms.forEach(function (imagezoom) {
    var toggle = document.createElement('button');
    toggle.className = 'image-zoom-js-toggle';
    toggle.addEventListener('click', function () {
      if (toggle.classList.contains('active')) {
        toggle.classList.remove('active');
        imagezoom.classList.remove('active');
        deactivateZoom(imagezoom);
      } else {
        toggle.classList.add('active');
        imagezoom.classList.add('active');
        activateZoom(imagezoom);
      }
    });
    imagezoom.appendChild(toggle);
  });
};
export { initImageZoom };